import { render, staticRenderFns } from "./wzvz_overview_all_hdr.vue?vue&type=template&id=04df6b7a&scoped=true"
import script from "./wzvz_overview_all_hdr.vue?vue&type=script&lang=js"
export * from "./wzvz_overview_all_hdr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df6b7a",
  null
  
)

export default component.exports